import Vertex from "./vertex";
import State from "./state";
import Rectangle from "./rectangle";
import Graph from "./graph";

export default class View {
    graph: Graph;
    constructor(graph: Graph) {
        this.graph = graph;
    }
    getBounds(cells: Vertex[], boundingBox: boolean): Rectangle {
        let result: Rectangle = new Rectangle(0,0,0,0);
        let first = true;

		if (cells != null && cells.length > 0)
		{
			const model = this.graph.getModel();

			for (let i = 0; i < cells.length; i++)
			{
				if (model.isVertex(cells[i]) || model.isEdge(cells[i]))
				{
					const state: State | null = this.getState(cells[i]);

					if (state != null)
					{
						const tmp: Rectangle | null = (boundingBox) ? state.getBoundingBox() : state;

						if (tmp != null)
						{
							if (first)
							{
                                result = tmp;
                                first = false;
							}
							else
							{
								result.add(tmp);
							}
						}
					}
				}
			}
		}

		return result;
    }
    getVisibleTerminal(arg0: Vertex, arg1: boolean): Vertex {
        return arg0;
    }
    getState(cell: Vertex): State | null {  
		return null;
    }

}